<script>
    import * as svelteInternal from "svelte/internal";

    // const originalDetach = svelteInternal.detach;

    // detach 関数を上書き
    svelteInternal.detach = function (node) {
        // console.log('Svelte Bug Fix:', node);
        // originalDetach(node);  // 元の動作も実行
        if (node.parentNode == null) return;
        node.parentNode.removeChild(node);
    };
</script>
